import { render, staticRenderFns } from "./ChangeEmailScreen.vue?vue&type=template&id=aec695de&"
import script from "./ChangeEmailScreen.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aec695de')) {
      api.createRecord('aec695de', component.options)
    } else {
      api.reload('aec695de', component.options)
    }
    module.hot.accept("./ChangeEmailScreen.vue?vue&type=template&id=aec695de&", function () {
      api.rerender('aec695de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/screens/ChangeEmailScreen.vue"
export default component.exports